import { Injectable } from '@angular/core';
import {
  GetCashOutRepository
} from '@private/modules/cash-out-payment/core/repositories/get-cash-out/get-cash-out.repository';
import { ApiService } from '@nequi/design-system-lib/logic';
import { GetCashOutRequestEntity, GetCashOutResponseEntity } from '@private/modules/cash-out-payment/core/entities';
import { ApiHeaderGenerateService } from '@shared/services/api-header-generate/api-header-generate.service';
import { HttpParams } from '@angular/common/http';
import { Response } from '@private/modules/cash-out-payment/core/entities/response.entity';


@Injectable()
export class GetCashOutImplRepository extends GetCashOutRepository {

  constructor(private readonly apiService: ApiService,
              private readonly apiHeaderGenerateService: ApiHeaderGenerateService) {
    super();
  }

  public async getTransaction(param: GetCashOutRequestEntity): Promise<GetCashOutResponseEntity> {
    const params = new HttpParams()
      .set('trazabilityCode', param.trazabilityCode)
      .set('ticketId', param.ticketId);
    const url = 'cashout';
    const headers = this.apiHeaderGenerateService.generateAuthHeaders();
    const response = await this.apiService.get<Response<GetCashOutResponseEntity>>(url, { params, headers });
    return response.data;
  }

}
